import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import api from "../api.js";
import { Box, colors, Grid, Link, MenuItem, Paper, Select, Stack, styled, TextField, Typography, useTheme } from '@mui/material';
import logo from '../img/kre-sans-texte-white.png';
import './Login.css';
import { Container } from '@mui/material';
import Button from '@mui/material/Button'
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import PasswordTextField from '../components/PasswordTextField.jsx';
import { useTranslation } from 'react-i18next';

const LanguageSelector = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    paddingLeft: "1em",
    paddingRight: "1em",
    paddingTop: "0.5em",
    paddingBottom: "0.5em",
    borderRadius: "5px",
    border: "0px solid #000",
    backgroundColor: "#fff",
    color: "#000",
  },
  '& .MuiSelect-icon': {
    color: "#000",
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: "#fff",
    color: "#000",
  },
  boxShadow: "none",
  "& .MuiOutlinedInput-notchedOutline": {
    border: 0,
  },
  border: "0px solid #000",
}));

export const Login = (props) => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorLog, setErrorLog] = useState("");

  const theme = useTheme();

  const { t, i18n } = useTranslation();


  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      var res = await api.post('/login/', { username: username, password: password })
      if (res.status === 200) {
        let loginToken = res.data.token;
        let mfaMethods = res.data.mfa_methods;
        if (mfaMethods.length > 0) {
          navigate("/verify-mfa/" + loginToken, { state: { mfaMethods: mfaMethods, username: username } })
        }

      }
      else {
        setErrorLog("Aucun compte actif avec cet identifiant et ce mot de passe")
      }


    } catch (error) {
      alert(error);
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  return (
    <div className="login-wrapper">

<Grid container borderRadius={"10px"}
        justifyContent="center"
        alignItems="stretch"
        display={"flex"}
        component={Paper}
      >
        <Grid item xs={12} borderRadius={"10px"} sm={12} md={7} justifyContent={"center"} alignItems={"center"} display={"flex"} sx={{ backgroundColor: "#1f1f1f"}}>
        <img src="https://assets-global.website-files.com/5f035e945f2bd77b8ea0c15b/5f15b385477cd1438376b984_20170112-EventsWork-Logo-Inverse-jaune_2.svg" loading="lazy" alt="Logo Events.Work"/>
        </Grid>
        <Grid  className="login-right" item xs={12} sm={12} md={5}
          component={Paper}
        >
          <LanguageSelector value={i18n.language} onChange={(e) => changeLanguage(e.target.value)}
            size='small'
            sx={{
              position: "absolute",
              top: "1em",
              right: "1em"
            }}
          >
            <MenuItem value="fr">FR</MenuItem>
            <MenuItem value="en">EN</MenuItem>
          </LanguageSelector>
          <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%", padding: "1em" }}>
            <Stack
              spacing={{ md: 6, sm: 3, xs: 3 }}
              justifyContent="space-between"
              height={"100%"}
              alignItems="center"


            >
              <Typography variant='h4'>{t('Login')}</Typography>

              <Stack
                width={(isMobile ? "100%" : "80%")}
                spacing={1}
              >
                <TextField
                  label={t("Email address")}
                  autoFocus={true}
                  className={"form-field " + (errorLog && "invalid")}
                  type="email"
                  fullWidth
                  onChange={e => { setUserName(e.target.value); setErrorLog("") }}
                  variant="standard" />

                <PasswordTextField
                  label={t("Password")}
                  type="password"
                  name="password"
                  onChange={e => { setPassword(e.target.value); setErrorLog("") }}
                  className={"form-field " + (errorLog && "invalid")}
                  autoComplete="false"
                  fullWidth
                  variant="standard"
                />
                {
                  errorLog ?
                    <Box sx={{ width: '100%' }}>
                      <Typography variant="body1" textAlign={"center"} color="error">{errorLog}</Typography>
                    </Box>
                    :
                    <Box sx={{ width: '100%', visibility: "hidden", height: "3em" }}>

                    </Box>
                }
              </Stack>
              <Button variant="contained" type="submit">{t('Login')}</Button>
              <div style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
                {/* <Link href='/register'>S'enregistrer</Link> */}
              </div>
            </Stack>

          </form>


        </Grid>
      </Grid>

    </div>
  )
}
